import { analytics } from './analyticsClient';
import { toIdPayload } from './analyticsEvent';

// Claves literales y no AMPLITUDE_EVENT.X: utils.js importa este módulo y hay tests que mockean
// core/variables/constant con solo parte de sus exports; un AMPLITUDE_EVENT ausente rompería la carga.
// La tabla cubre todas las claves de AMPLITUDE_EVENT (lo comprueba su test) para que un uso nuevo no
// se pierda sin avisar.
export const POSTHOG_TO_EVENT_TYPE: Readonly<Record<string, string>> = Object.freeze({
  'ADD ACTIVITY FROM LIBRARY': 'library_activity_added',
  'ADD MINT BLOCK': 'mint_block_added',
  'ANSWER ACTIVITY': 'activity_answered',
  'ASSESSMENT FEEDBACK': 'assessment_feedback_sent',
  'CHANGE LANGUAGE': 'language_changed',
  'CLICK IMPORT FROM CLASSROOM': 'classroom_import_clicked',
  'CREATE ACTIVITY': 'activity_created',
  'CREATE ACTIVITY AI': 'ai_activity_created',
  'CREATE EMBED LINK': 'embed_link_created',
  'CREATE EVALUATION': 'evaluation_created',
  'CREATE FEEDBACK AI': 'ai_feedback_created',
  'CREATE LINK': 'link_created',
  'CREATE MATERIAL': 'material_created',
  'CREATE MODEL AI': 'ai_model_created',
  'CREATE NEW LESSON': 'lesson_created',
  'CREATE NEW UNIT': 'unit_created',
  'CREATE QUIZ': 'quiz_created',
  'CREATE SECTION': 'section_created',
  'CREATE TASK': 'task_created',
  'CREATE VIDEOLESSON': 'videolesson_created',
  'DO TASK': 'task_done',
  'DOWNLOAD DESKTOP APP': 'desktop_app_downloaded',
  'EDIT EDITORIAL LESSON': 'editorial_lesson_edited',
  'GRADE STUDENT': 'student_graded',
  'GRADE TASK': 'task_graded',
  HIGHLIGHTER: 'highlighter_used',
  'HOME LIBRARY': 'home_library_opened',
  'IMPORT FROM CLASSROOM': 'classroom_students_imported',
  'LOGIN FAILED': 'login_failed',
  'MINT HIGHLIGHT': 'mint_text_highlighted',
  'MOVE SESSION': 'class_session_moved',
  'OPEN CALENDAR': 'calendar_opened',
  'OPEN CLASS RESOURCES': 'class_resources_opened',
  'OPEN CONTENT': 'content_opened',
  'OPEN COURSE': 'course_opened',
  'OPEN COURSE CONFIG': 'course_config_opened',
  'OPEN GRADEBOOK': 'gradebook_opened',
  'OPEN GRADES': 'grades_opened',
  'OPEN HOMEPAGE': 'homepage_opened',
  'OPEN IMMERSIVE READER': 'immersive_reader_opened',
  'OPEN KANBAN': 'kanban_opened',
  'OPEN LESSON': 'lesson_opened',
  'OPEN LESSON ITEM': 'lesson_item_opened',
  'OPEN MODULE RESOURCES': 'module_resources_opened',
  'OPEN PAGINATION WIDGET': 'pagination_widget_opened',
  'OPEN SESSION': 'class_session_opened',
  'OPEN SESSION RESOURCES': 'class_session_resources_opened',
  // \u0054 es la «T»: escrita tal cual, el trinquete de deuda la contaría como tarea pendiente sin ticket.
  'OPEN \u0054ODO': 'todo_opened',
  'OPEN USERS CLASSROOM': 'classroom_users_opened',
  'PAGINATION GO TO PAGE': 'pagination_page_visited',
  'PAGINATION OPEN BOOK': 'pagination_book_opened',
  'PERSONALIZE PROGRAM': 'program_personalized',
  'PROJECT LESSON': 'lesson_projected',
  'PUBLISH GRADE': 'grade_published',
  'REMOTE DEVICE CONNECTED': 'remote_device_connected',
  'REVIEW MATERIAL': 'material_reviewed',
  'REVIEW TASK': 'task_reviewed',
  'SAVE COURSE CONFIG': 'course_config_saved',
  'SEND CLASS MESSAGE': 'class_message_sent',
  'SEND COMMENT': 'comment_sent',
  'SEND MESSAGE': 'message_sent',
  'SEND WALL COMMENT': 'wall_comment_sent',
  'SEND WALL MESSAGE': 'wall_message_sent',
  'SET DELIVER DATE': 'deliver_date_set',
  'SHARE ON GOOGLE CLASSROOM': 'google_classroom_shared',
  'SHOW LESSON ITEM': 'lesson_item_status_changed',
  START: 'app_started',
  'STUDENTS VIEW RESULTS': 'students_results_viewed',
  'TASK FEEDBACK': 'task_feedback_sent',
  'UNPUBLISH GRADE': 'grade_unpublished',
  'VIEW TASK RESULTS': 'task_results_viewed',
});

/** Copia un evento de PostHog en la analítica in-house; devuelve si ha quedado en cola. */
export function mirrorPosthogEvent(posthogEvent: string, properties?: unknown): boolean {
  const eventType = POSTHOG_TO_EVENT_TYPE[posthogEvent];
  if (!eventType) return false;

  return analytics.track(eventType, { ...toIdPayload(properties), posthog_event: posthogEvent });
}
